var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('create-budget-form',{on:{"on-submit":_vm.onCreateModelSubmit}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }